import { createQueryString } from "common/app/query-string";
import { splitPath } from "common/app/router";
import { Context } from "common/types/context";
import { QueryString } from "common/types/url";

export const changeSite = (
  path: string,
  queryString: QueryString,
  newSite?: string,
) => {
  const qs = createQueryString(queryString);
  const [site, ...rest] = splitPath(path);
  return [newSite || site, ...rest, qs].filter((s) => !!s).join("/");
};

export const removeIdFromPath = (path: string) =>
  splitPath(path).slice(0, 2).join("/");

export const getExplorerEntity = (path: string, context: Context) => {
  const pathParts = path.split("/");
  const page = pathParts[0] === "" ? pathParts[2] : pathParts[1];
  return context.entities[page] ? page : undefined;
};
